export class CommentObject {
	public id: number;
	public parentComment: number;
	public user: string;
	public email: string;
	public comment: string;
	public date: Date;
	public childComments: Comment[];
	public commentCount: number;
}
